// Clover-shop Google TagManager
//   https://tagmanager.google.com/#/container/accounts/2812571911/containers/8702647/workspaces/186
const GTM_ID = 'GTM-5J6LMFK';

export function initializeGTM() {
  const script = document.createElement('script');
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','${GTM_ID}');`;
  if (document && document.head) {
    document.head.appendChild(script);
  }
}
